import React from "react";
import assetify from "@quintype/framework/assetify";
import { string } from "prop-types";

import DefaultDesktopLogo from "../../../../assets/images/palo-bangla.svg";
import KishoraloLogo from "../../../../assets/images/kishoralo.svg";
import protichintaIcon from "../../../../assets/images/protichinta-icon.png";
import BigganChintaLogo from "../../../../assets/images/biggan-chinta.svg";
import trustLogo from "../../../../assets/images/trust-logo.png";
import EnglishHeaderLogo from "../../../../assets/images/palo-english.svg";
import NagorikLogo from "../../../../assets/images/nagorik.svg";
import { headerLevelLogo } from "../../utils/utils";
import naLogo from "../../../../assets/images/Na_logo.svg";
import Icon from "../../icons";

import "./desktopLogo.m.css";

const DesktopLogo = ({ lang, pageType, location }) => {
  const HeaderTag = `h${headerLevelLogo(pageType)}`;
  const renderLogo = () => {
    if (location === "kishoralo") {
      return <img src={`${assetify(KishoraloLogo)}`} styleName="kishoralo-logo" />;
    } else if (location === "bondhushava") {
      return <Icon type="bondhushava" className="bondhushava" />;
    } else if (location === "protichinta") {
      return (
        <img
          src={`${assetify(protichintaIcon)}`}
          alt="ad-slot-768-x90"
          styleName="protichinta-logo"
          className="protichinta-desktop-logo"
        />
      );
    } else if (location === "bigganchinta") {
      return <img src={`${assetify(BigganChintaLogo)}`} styleName="biggan-chinta-logo" />;
    } else if (location === "trust") {
      return <img src={`${assetify(trustLogo)}`} alt="trust-logo" className="desktop-trust-logo trust-logo" />;
    } else if (location === "nagorik-sangbad") {
      return <img src={`${assetify(NagorikLogo)}`} styleName="nagorik-logo" />;
    } else if (location === "northamerica") {
      return <img src={`${assetify(naLogo)}`} alt="na-logo" className="desktop-na-logo na-logo" />;
    } else if (lang === "en") {
      return <img src={`${assetify(EnglishHeaderLogo)}`} alt="palo-logo" styleName="palo-english-logo" />;
    } else {
      return <img src={`${assetify(DefaultDesktopLogo)}`} alt="palo-logo" styleName="palo-logo" />;
    }
  };

  return <HeaderTag className="desktop-logo">{renderLogo()}</HeaderTag>;
};

DesktopLogo.propTypes = {
  domainSlug: string,
  lang: string,
  pageType: string,
  location: string,
};

export default DesktopLogo;
